<template>
  <div class="search">
    <el-form ref="form" inline :model="formData" :label-width="labelWidth">
      <el-form-item
        v-for="item in formOptions"
        :key="item.prop"
        :label="item.label"
        :label-width="item.labelWidth ? item.labelWidth : labelWidth || '100px'"
        :style="{width: item.width || itemWidth}"
      >
        <el-input
          v-if="item.type === 'input' || undefined"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || '请输入'"
          @change="(val) => formItemChang(val, item.prop)"
          clearable
        ></el-input>
        <el-select
          v-if="item.type === 'select'"
          v-model="formData[item.prop]"
          :multiple="item.multiple"
          :placeholder="item.placeholder || '请选择'"
          @change="(val) => formItemChang(val, item.prop)"
          clearable
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <el-select
          v-if="item.type === 'select-search'"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || '请输入'"
          @change="(val) => formItemChang(val, item.prop)"
          :remote-method="(query) => selectRemoteMethod(query, item)"
          :loading="selectLoading"
          clearable
          filterable
          remote
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <el-time-picker
          v-if="item.type === 'range-picker'"
          is-range
          v-model="formData[item.prop]"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-time-picker>
        <el-date-picker
          v-if="item.type === 'range-date'"
          v-model="formData[item.prop]"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder="选择日期范围"
          value-format="yyyy-MM-dd"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-date-picker>
         <!-- 日期时间区间 -->
        <el-date-picker
          v-if="item.type === 'range-date-time'"
          v-model="formData[item.prop]"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd hh:mm:ss"
          :disabled="item.disabled"
        >
        </el-date-picker>
        <el-cascader
          v-if="item.type === 'cascader'"
          v-model="formData[item.prop]"
          :options="item.options"
          :props="item.propConfig || {}"
          @change="(val) => formItemChang(val, item.prop)"
          :placeholder="item.placeholder || '请选择'"
          clearable
        >
        </el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch"><i class="el-icon-search"></i> 搜索</el-button>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message } from 'element-ui'

export default {
  name: 'BaseSearch',
  props: {
    // form 配置
    formOptions: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    // 全局label宽度控制
    labelWidth: {
      type: String,
      default: '70px'
    },
    itemWidth: {
      type: String,
      default: '20%'
    },
    searchNotNull: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'formData',
    event: 'change'
  },
  data() {
    return {
      selectLoading: false,
      searchData: {},
      isPrivacy: this.$store.state.user.group_id == 17,   // 账号等级，17为报价员，需要做数据隐私处理
    }
  },
  created() {
  },
  methods: {
    // change事件
    formItemChang() {
      // arguments  val  prop
      this.searchData = {...arguments}
      this.$emit('formItemChang', ...arguments)
    },
    // 搜索框远程搜索触发函数
    selectRemoteMethod(val, optionItem) {
      this.selectLoading = true
      optionItem.remoteMethod(val, () => {
        this.selectLoading = false
      })
    },
    // 点击搜索
    handleSearch() {
      //判断this.searchData对象是否为空
      if(this.isPrivacy) {
        if (Object.keys(this.searchData).length === 0 || this.searchData[0] === '' && this.searchNotNull === false) {
          // 搜索框不触发change事件，并给出错误提示
          Message({
            message: '请输入搜索内容',
            type: 'error',
            showClose: true,
            duration: 3 * 1000
          })
          return
        }
      }
      this.$emit('handleSearch')
    },
  }
}
</script>

<style lang="scss" scoped>
.search {
  :deep(.el-form)  {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      flex-shrink: 0;
    }
    .el-form-item__content {
      flex: 1;
    }
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-cascader {
      width: 100%;
    }
  }
  
}
</style>
